var _ellipse, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 6,
    ry: 6,
    transform: "translate(7 7)",
    fill: "none",
    stroke: "#0F1621",
    strokeWidth: 2,
    strokeOpacity: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 14,
    y2: 14,
    fill: "none",
    stroke: "#0F1621",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.973389838f78b3727c6fb2427d316926.svg";
export { ForwardRef as ReactComponent };